<!-- 常量分类管理 -->
<template>
  <el-card>
    <div class="toolbar">
      <el-button type="primary" @click="onCreateItem()">
        <i class="fas fa-plus"></i> 新增分类
      </el-button>
      <div class="former">
        <el-input
          clearable
          v-model="form['Name|Code:like']"
          placeholder="分类名称或分类编码"
          @keydown.enter.native="onSubmitQuery"
        ></el-input
        >&nbsp;
        <el-button type="primary" @click="onSubmitQuery">
          <i class="fas fa-search"></i>
        </el-button>
      </div>
    </div>
    <el-table
      ref="multipleTable"
      size="medium"
      :data="itemList"
      v-loading="loading"
    >
      <el-table-column
        type="index"
        :index="pager.size * (pager.page - 1) + 1"
        :width="Math.max(48, (pager.size * pager.page).toString().length * 12)"
      ></el-table-column>
      <el-table-column prop="Name" label="分类名称"></el-table-column>
      <el-table-column
        prop="Code"
        label="分类编码"
        width="200"
      ></el-table-column>
      <el-table-column prop="Sort" label="排序值" width="200"></el-table-column>
      <el-table-column prop="Remark" label="备注" width="200"></el-table-column>
      <el-table-column width="160" label="操作">
        <template slot-scope="scope">
          <el-button
            type="primary"
            @click.stop="onEditItem(scope.row)"
            title="编辑"
          >
            <i class="fas fa-pencil-alt"></i>
          </el-button>
          <el-button
            type="primary"
            @click.stop="onEditData(scope.row)"
            title="常量数据"
          >
            <i class="fas fa-cogs"></i>
          </el-button>
          <el-button
            type="danger"
            @click.stop="onDeleteItem(scope.row)"
            title="删除"
          >
            <i class="fas fa-trash-alt"></i>
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="clearfix mar-top-10">
      <el-pagination
        class="pull-right"
        @current-change="onChangePage"
        layout="total, prev, pager, next"
        :total="pager.total"
        :current-page="pager.page"
        :page-size="pager.size"
      ></el-pagination>
    </div>
    <item-form
      v-model="item"
      :visible.sync="itemVisible"
      :isEdit="isEdit"
      @form:saved="getItemList"
    />
  </el-card>
</template>

<script>
import ItemForm from "./form.vue";

export default {
  components: {
    ItemForm,
  },
  data() {
    return {
      itemList: [],
      loading: false,
      pager: {
        total: 0,
        page: 1,
        size: 15,
      },
      form: {
        "Name:like": "",
        "Code:like": "",
      },
      item: this.getEmptyItem(),
      itemVisible: false,
      isEdit: false,
    };
  },
  mounted() {
    this.getItemList();
  },
  methods: {
    getItemList() {
      //获取常量分类列表
      this.loading = true;
      this.$axios
        .get("basicclassify", {
          params: {
            where: this.form,
            with: ["Basics"],
            ...this.pager,
            order: ["-sort", "name"],
          },
        })
        .then((response) => {
          this.itemList = response.data.data;
          this.pager = _.pick(response.data, "size", "page", "total");
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onSubmitQuery() {
      this.pager.page = 1;
      this.getItemList();
    },
    onChangePage(page) {
      this.pager.page = page;
      this.getItemList();
    },
    onCreateItem() {
      this.item = this.getEmptyItem();
      this.isEdit = false;
      this.itemVisible = true;
    },
    onEditItem(row) {
      this.item = row;
      this.isEdit = true;
      this.itemVisible = true;
    },
    onEditData(row) {
      this.$router.push({ name: 'BasicData', params: { ID: row.ID } });
    },
    onDeleteItem(row) {
      this.$confirm("确定要删除该分类吗？", "提示")
        .then(() => this.$axios.delete(`basicclassify/${row.ID}`))
        .then(() => {
          this.getItemList();
          this.$message.success("成功删除");
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        });
    },
    getEmptyItem() {
      return {
        Name: "", //分类名称
        Code: "", //分类编码
        Sort: 0, //排序
        Remark: "", //备注
      };
    },
  },
};
</script>
